import React, { useEffect } from "react";
import { Icon } from "antd";

// URL builder + VIN GA helpers live alongside the main widget component
// (co-located pattern used elsewhere, e.g. PriceEstimateResult).
import {
  buildCarverticalUrl,
  trackCarverticalVinLinkClick,
  trackCarverticalVinLinkShown
} from "./CarverticalWidget";
import styles from "./carverticalWidget.scss";

interface Props {
  vin: string;
}

const CarverticalVinLink: React.FC<Props> = ({ vin }) => {
  useEffect(() => {
    trackCarverticalVinLinkShown();
  }, []);

  return (
    <a
      href={buildCarverticalUrl(vin)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={trackCarverticalVinLinkClick}
      className={styles.vinLink}
    >
      <Icon type="safety" className={styles.vinLinkIcon} />
      <span className={styles.vinLinkText}>{"Provjeri povijest"}</span>
      <span className={styles.vinLinkBadge}>{"20% popusta"}</span>
    </a>
  );
};

export default CarverticalVinLink;



// WEBPACK FOOTER //
// ./src/components/CarverticalWidget/CarverticalVinLink.tsx